import { SearchDocumentRequest } from "../components/operation/document/DocumentList";
import { PublishDocumentRequest } from "../redux/slice/document/DocumentSlice";
import { InterceptorOption } from "../types/CommonTypes";
import { http } from "./http";
import { AUTHENTICATE_EXTERNAL_LINK_URL, DELETE_PRODUCT_DOCUMENT_BY_ID_URL, GET_DOCUMENT_CATEGORY_LIST_URL, GET_PRODUCT_DOCUMENT_BY_ID_URL, GET_TEMPLATE_BY_TYPE_URL, PUBLISH_PRODUCT_DOCUMENT_URL, SEARCH_DOCUMENT_LIST_URL, ADD_PRACTICE_TEMPLATE_URL, GET_MANUFACTURER_TEMPLATES_URL, INACTIVE_PRACTICE_TEMPLATE_URL } from "./URL";

export const searchDocuments = async (searchDocumentRequest: SearchDocumentRequest) => {
  try {
    const response = await http.post(SEARCH_DOCUMENT_LIST_URL, searchDocumentRequest);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDocumentCategories = async (onlyPublished: boolean) => {
  try {
    const response = await http.get(`${GET_DOCUMENT_CATEGORY_LIST_URL}?onlyPublished=${onlyPublished}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkExternalLinkAuthentication = async (password: string, interceptorOption: InterceptorOption) => {
  try {
    const response = await http.post(AUTHENTICATE_EXTERNAL_LINK_URL,password, undefined,interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
};

export const publishDocument = async (publishDocumentRequest: PublishDocumentRequest) => {
  try {
    const response = await http.post(PUBLISH_PRODUCT_DOCUMENT_URL,publishDocumentRequest);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProductDocument = async (productDocumentId: number) => {
  try {
    const response = await http.post(GET_PRODUCT_DOCUMENT_BY_ID_URL,productDocumentId);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProdDocument = async (productDocumentId: number) => {
  try {
    const response = await http.post(DELETE_PRODUCT_DOCUMENT_BY_ID_URL,productDocumentId);
    return response;
  } catch (error) {
    throw error;
  }
};

//CS-1518 START
export const fetchTemplatesByType = async (templateType: string) => {
  try {
    const response = await http.get(`${GET_TEMPLATE_BY_TYPE_URL}/${templateType}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export interface AddPracticeTemplateRequest {
  practiceId: number;
  templateId: number;
  manufacturerId: number;
  templateLevel?: string;
}

export const addPracticeTemplate = async (data: AddPracticeTemplateRequest) => {
  try {
    const response = await http.post(ADD_PRACTICE_TEMPLATE_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export interface EditPracticeTemplateRequest {
  manufacturerPracticeTemplateId: number;
  practiceId: number;
  templateId: number;
  manufacturerId?: number;
  templateLevel?: string;
}

export const editPracticeTemplate = async (data: EditPracticeTemplateRequest) => {
  try {
    const response = await http.post(ADD_PRACTICE_TEMPLATE_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const inactivatePracticeTemplate = async (manufacturerPracticeTemplateId: number) => {
  try {
    const response = await http.get(`${INACTIVE_PRACTICE_TEMPLATE_URL}/${manufacturerPracticeTemplateId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchManufacturerTemplates = async (manufacturerId: string) => {
  try {
    const response = await http.get(`${GET_MANUFACTURER_TEMPLATES_URL}/${manufacturerId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export interface AddManufacturerTemplateRequest {
  manufacturerId: number;
  templateId: number;
  templateLevel?: string;
}

export const addManufacturerTemplate = async (data: AddManufacturerTemplateRequest) => {
  try {
    // For now, use the same endpoint as practice templates but with manufacturer data
    const requestData = {
      templateId: data.templateId,
      manufacturerId: data.manufacturerId,
      templateLevel: data.templateLevel || "Manufacturer"
    };
    const response = await http.post(ADD_PRACTICE_TEMPLATE_URL, requestData);
    return response;
  } catch (error) {
    throw error;
  }
};

export interface EditManufacturerTemplateRequest {
  manufacturerPracticeTemplateId: number;
  manufacturerId: number;
  templateId: number;
  templateLevel?: string;
}

export const editManufacturerTemplate = async (data: EditManufacturerTemplateRequest) => {
  try {
    const requestData = {
      manufacturerPracticeTemplateId: data.manufacturerPracticeTemplateId,
      templateId: data.templateId,
      manufacturerId: data.manufacturerId,
      templateLevel: data.templateLevel || "Manufacturer"
    };
    const response = await http.post(ADD_PRACTICE_TEMPLATE_URL, requestData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const inactivateManufacturerTemplate = async (manufacturerTemplateId: number) => {
  try {
    const response = await http.get(`${INACTIVE_PRACTICE_TEMPLATE_URL}/${manufacturerTemplateId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
//CS-1518 END
